<template>
  <div class="login-container">
    <el-alert
        v-if="nodeEnv !== 'development'"
        :title="`欢迎使用${title}`"
        type="success"
        :closable="false"
        style="position: fixed"
    >
    </el-alert>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
        <div style="color: transparent">占位符</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            class="login-form"
            label-position="left"
        >
          <div class="title">用户登录</div>

          <el-form-item style="margin-top: 40px" prop="username">
            <span class="svg-container">
              <span class="fa fa-user" />
            </span>
            <el-input
                v-model.trim="form.username"
                v-focus
                placeholder="请输入手机/邮箱/身份证"
                tabindex="1"
                type="text"
                clearable
            />
          </el-form-item>
          <el-form-item prop="password">
            <span class="svg-container">
              <span class="fa fa-lock" />
            </span>
            <el-input
                :key="passwordType"
                ref="password"
                v-model.trim="form.password"
                :type="passwordType"
                tabindex="2"
                placeholder="请输入密码"
                clearable
                @keyup.enter.native="handleLogin"
            />
            <span
                v-if="passwordType === 'password'"
                class="show-password"
                @click="handlePassword"
            >
              <span class="fa fa-eye-slash"></span>
            </span>
            <span v-else class="show-password" @click="handlePassword">
              <span class="fa fa-eye"></span>
            </span>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-button
                  :loading="loading"
                  class="login-btn"
                  type="primary"
                  @click="handleLogin"
              >
                <span class="fa fa-sign-in" style="padding-right: 5px"></span
                >登录
              </el-button>
            </el-col>
            <el-col :span="12">
              <router-link class="forget-password" to="/forgetPass">
                <div style="margin-top: 10px; margin-left: 20px">
                  <zr-icon icon="question"></zr-icon>
                  <span style="padding-right: 5px"> 忘记密码</span>
                </div>
              </router-link>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <router-link class="link-register" to="/adminLogin">
                <div style="margin-top: 20px">
                  <span>
                    <zr-icon
                        icon="user-cog"
                        style="padding-right: 5px"
                    ></zr-icon>
                    管理员登录
                  </span>
                </div>
              </router-link>
            </el-col>
            <el-col :span="6">
              <router-link class="link-register" to="/register">
                <div style="margin-top: 20px">
                  <span class="fa fa-id-badge" style="padding-right: 5px">
                    注册</span
                  >
                </div>
              </router-link>
            </el-col>
            <el-col :span="6">
              <router-link class="link-register" to="/">
                <div style="margin-top: 20px">
                  <span class="fa fa-home" style="padding-right: 5px">
                    首页</span
                  >
                </div>
              </router-link>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { isPassword } from "zr-util/src/utils/comm/validate";

export default {
  name: "Login",
  directives: {
    focus: {
      inserted(el) {
        el.querySelector("input").focus();
      },
    },
  },
  data() {
    const validateusername = (rule, value, callback) => {
      if ("" == value) {
        callback(new Error("用户名不能为空"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!isPassword(value)) {
        callback(new Error("密码不能少于6位"));
      } else {
        callback();
      }
    };
    return {
      textSlider: "",
      accuracy: 5,
      nodeEnv: process.env.NODE_ENV,
      title: this.$baseTitle,
      form: {
        username: "",
        password: "",
        curRole: "user",
      },
      rules: {
        username: [
          {
            required: true,
            trigger: "blur",
            validator: validateusername,
          },
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            validator: validatePassword,
          },
        ],
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
      query: undefined,
      // 防暴力破解 - 用于本地检测（后端为主）
      remainingAttempts: null, // 剩余尝试次数
      isLocked: false,         // 是否被锁定
      lockRemainingMinutes: 0, // 剩余锁定时间
    };
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = (route.query && route.query.redirect) || "/";
        this.query = route.query || {};
      },
      immediate: true,
    },
  },
  mounted() {
    if ("production" !== process.env.NODE_ENV) {
      this.form.username = "root";
      this.form.password = "123456";
    }
  },
  methods: {
    handleTabClick(tab) {
      this.activeName = tab.name;
    },
    handlePassword() {
      this.passwordType === "password"
          ? (this.passwordType = "")
          : (this.passwordType = "password");
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },

    /**
     * 解析后端返回的错误消息，提取剩余尝试次数和锁定信息
     * @param {string} message 错误消息
     * @returns {object} 解析结果
     */
    parseLoginErrorMessage(message) {
      const result = {
        isLocked: false,
        isWarning: false,
        remainingAttempts: null,
        lockRemainingMinutes: null,
        displayMessage: message
      };

      // 检查是否被锁定
      const lockMatch = message.match(/锁定\s*(\d+)\s*分钟/);
      if (lockMatch) {
        result.isLocked = true;
        result.lockRemainingMinutes = parseInt(lockMatch[1]);
        return result;
      }

      // 检查剩余尝试次数
      const attemptsMatch = message.match(/还有\s*(\d+)\s*次/);
      if (attemptsMatch) {
        result.remainingAttempts = parseInt(attemptsMatch[1]);
        if (result.remainingAttempts <= 2) {
          result.isWarning = true;
        }
      }

      return result;
    },

    /**
     * 显示登录错误提示
     * @param {string} message 错误消息
     * @param {boolean} isLocked 是否被锁定
     */
    showLoginError(message, isLocked = false) {
      if (isLocked) {
        // 锁定状态使用警告提示
        this.$message({
          message: message,
          type: 'warning',
          duration: 5000,
          showClose: true
        });
      } else {
        // 普通错误使用普通提示
        this.$message({
          message: message,
          type: 'error',
          duration: 3000,
          showClose: true
        });
      }
    },

    handleLogin() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 前端防暴力破解检查
          if (this.isLocked) {
            this.$message({
              message: `账户已被锁定，请在 ${this.lockRemainingMinutes} 分钟后再试！`,
              type: 'warning',
              duration: 5000,
              showClose: true
            });
            return;
          }

          this.loading = true;

          try {
            const success = await this.$store
                .dispatch("user/studentLogin", this.form);

            if (success) {
              // 登录成功，重置状态
              this.isLocked = false;
              this.remainingAttempts = null;
              this.lockRemainingMinutes = 0;

              const routerPath =
                  this.redirect === "/404" || this.redirect === "/401"
                      ? "/"
                      : this.redirect;
              await this.$router
                  .push({ path: routerPath, query: this.query })
                  .catch(() => {});
            }
          } catch (error) {
            // 处理登录失败的错误信息
            let errorMessage = "登录失败，请稍后重试";

            if (error && error.message) {
              errorMessage = error.message;
            } else if (error && error.data && error.data.message) {
              errorMessage = error.data.message;
            }

            // 解析错误消息
            const parsed = this.parseLoginErrorMessage(errorMessage);

            // 更新本地状态
            if (parsed.isLocked) {
              this.isLocked = true;
              this.lockRemainingMinutes = parsed.lockRemainingMinutes;
            } else if (parsed.remainingAttempts !== null) {
              this.remainingAttempts = parsed.remainingAttempts;
            }

            // 显示错误提示
            this.showLoginError(errorMessage, parsed.isLocked);
          } finally {
            this.loading = false;
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  background: url("~@/assets/login_images/bg_earth_sky.jpg") center center fixed
  no-repeat;
  background-size: cover;

  .title {
    font-size: 40px;
    font-weight: 500;
    color: $base-color-white;
  }

  .title-tips {
    margin-top: 29px;
    font-size: 26px;
    font-weight: 400;
    color: rgba(92, 102, 240, 1);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .role-tips {
    margin-top: 29px;
    font-size: 26px;
    font-weight: 400;
    color: $base-color-yellow;
    text-overflow: ellipsis;
  }

  #roleBox {
    float: right;
    height: 30px;
    .el-input input {
      font-size: 16px;
      font-weight: 100;
      height: 30px;
      padding-left: 0;
    }
  }

  .login-btn {
    display: inherit;
    width: 160px;
    height: 50px;
    margin-top: 5px;
    font-size: 18px;
    border: 0;

    &:hover {
      opacity: 0.9;
    }
  }

  .login-form {
    position: relative;
    max-width: 100%;
    margin: calc((100vh - 425px) / 2) 10% 10%;
    overflow: hidden;
  }

  .tips {
    margin-bottom: 10px;
    font-size: $base-font-size-default;
    color: $base-color-white;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .title-container {
    position: relative;

    .title {
      margin: 0 auto 40px auto;
      font-size: 34px;
      font-weight: bold;
      color: $base-color-blue;
      text-align: center;
    }
  }

  .svg-container {
    position: absolute;
    top: 14px;
    left: 15px;
    z-index: $base-z-index;
    font-size: 16px;
    color: #d7dee3;
    cursor: pointer;
    user-select: none;
  }

  .show-password {
    position: absolute;
    top: 14px;
    right: 25px;
    font-size: 16px;
    color: #d7dee3;
    cursor: pointer;
    user-select: none;
  }

  a.link-register {
    font-size: 20px;
    color: #409eff;
  }

  a.forget-password {
    font-size: 21px;
    color: #ffce2d;
  }

  ::v-deep {
    .el-form-item {
      padding-right: 0;
      margin: 20px 0;
      color: #454545;
      background: transparent;
      border: 1px solid transparent;
      border-radius: 2px;

      &__content {
        min-height: $base-input-height;
        line-height: $base-input-height;
      }

      &__error {
        position: absolute;
        top: 100%;
        left: 18px;
        font-size: $base-font-size-small;
        line-height: 18px;
        color: $base-color-red;
      }
    }

    .el-input {
      box-sizing: border-box;

      input {
        height: 58px;
        padding-left: 45px;
        font-size: $base-font-size-default;
        line-height: 58px;
        color: $base-font-color;
        background: #f6f4fc;
        border: 0;
        caret-color: $base-font-color;
      }
    }
  }
}
</style>
